<section *ngIf="predmet" class="p-3">

  <lib-dialog-header
    [titulok]="titulok"
    [predmetNazov]="predmet.nazov"
    [predmetSkratka]="predmet.skratkaFull">
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography p-0">

    <div class="container">

      <section class="d-flex flex-column d-md-none" *ngIf="!isStatnicovyPredmet">

        <div class="fw-bold text-black" i18n>Vyučujúci predmetu</div>
        <div>{{predmet.vyucujuci}}</div>

        <div class="mt-4 fw-bold text-black" i18n>Počet kreditov</div>
        <div>{{predmet.pocetKreditov}}</div>

        <div class="mt-4 fw-bold text-black" i18n>Forma výučby</div>
        <div>{{predmet.formaVyucby}}</div>

        <div class="mt-4 fw-bold text-black" i18n>Podmieňujúce predmety</div>
        <div>{{predmet.podmienujucePredmety}}</div>

        <div class="mt-4 fw-bold text-black" i18n>Spôsob ukončenia</div>
        <div>{{predmet.sposobUkoncenia}}</div>

        <div class="mt-3 fw-bold text-black" i18n>Jazyk výučby</div>
        <div>{{predmet.jazykVyucby}}</div>

      </section>

      <table class="d-none d-md-table" *ngIf="!isStatnicovyPredmet">
        <tr>
          <td><span class="col fw-bold" i18n>Vyučujúci predmetu</span></td>
          <td>{{predmet.vyucujuci}}</td>
        </tr>
        <tr>
          <td><span class="col fw-bold" i18n>Počet kreditov</span></td>
          <td>{{predmet.pocetKreditov}}</td>
        </tr>
        <tr>
          <td><span class="col fw-bold" i18n>Forma výučby</span></td>
          <td>{{predmet.formaVyucby}}</td>
        </tr>
        <tr>
          <td nowrap="nowrap"><span class="col fw-bold" i18n>Podmieňujúce predmety</span></td>
          <td>{{predmet.podmienujucePredmety}}</td>
        </tr>
        <tr>
          <td><span class="col fw-bold" i18n>Spôsob ukončenia</span></td>
          <td>{{predmet.sposobUkoncenia}}</td>
        </tr>
        <tr>
          <td><span class="col fw-bold" i18n>Jazyk výučby</span></td>
          <td>{{predmet.jazykVyucby}}</td>
        </tr>
      </table>

      <section class="d-flex flex-column d-md-none" *ngIf="isStatnicovyPredmet">
        <div class="mt-0 fw-bold text-black" i18n>Počet kreditov</div>
        <div>{{predmet.pocetKreditov}}</div>
        <ng-container *ngIf="predmet.podmienujucePredmety">
          <div class="mt-2 fw-bold text-black" i18n>Podmieňujúce predmety</div>
          <div>{{predmet.podmienujucePredmety}}</div>
        </ng-container>
        <ng-container *ngIf="predmet.vylucujucePredmety">
          <div class="mt-2 fw-bold text-black" i18n>Vylučujúce predmety</div>
          <div>{{predmet.vylucujucePredmety}}</div>
        </ng-container>
        <ng-container *ngIf="predmet.alternujucePredmety">
          <div class="mt-2 fw-bold text-black" i18n>Alternujúce predmety</div>
          <div>{{predmet.alternujucePredmety}}</div>
        </ng-container>
      </section>

      <table class="d-none d-md-table" *ngIf="isStatnicovyPredmet">
        <tr>
          <td><span class="col fw-bold" i18n>Počet kreditov</span></td>
          <td>{{predmet.pocetKreditov}}</td>
        </tr>
        <tr *ngIf="predmet.podmienujucePredmety">
          <td nowrap="nowrap"><span class="col fw-bold" i18n>Podmieňujúce predmety</span></td>
          <td>{{predmet.podmienujucePredmety}}</td>
        </tr>
        <tr *ngIf="predmet.vylucujucePredmety">
          <td nowrap="nowrap"><span class="col fw-bold" i18n>Vylučujúce predmety</span></td>
          <td>{{predmet.vylucujucePredmety}}</td>
        </tr>
        <tr *ngIf="predmet.alternujucePredmety">
          <td nowrap="nowrap"><span class="col fw-bold" i18n>Alternujúce predmety</span></td>
          <td>{{predmet.alternujucePredmety}}</td>
        </tr>
      </table>

    </div>

    <mat-accordion class="mt-5 m-sm-5">

      <mat-expansion-panel *ngIf="!isStatnicovyPredmet">
        <mat-expansion-panel-header>
          <mat-panel-title><span class="fw-bold" i18n>Stručná osnova predmetu</span></mat-panel-title>
        </mat-expansion-panel-header>
        <hr/>
        <section *ngFor="let i of predmet.popisy">
          <div class="small text-black-50" *ngIf="i.typ === 'SO'">{{i.text}}</div>
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="!isStatnicovyPredmet">
        <mat-expansion-panel-header>
          <mat-panel-title><span class="fw-bold" i18n>Podmienky na absolvovanie predmetu</span></mat-panel-title>
        </mat-expansion-panel-header>
        <hr/>
          <section *ngFor="let i of predmet.popisy">
            <div class="small text-black-50" *ngIf="i.typ === 'PA'">{{i.text}}</div>
          </section>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="!isStatnicovyPredmet">
        <mat-expansion-panel-header>
          <mat-panel-title><span class="fw-bold" i18n>Výsledky vzdelávania</span></mat-panel-title>
        </mat-expansion-panel-header>
        <hr/>
          <section *ngFor="let i of predmet.popisy">
            <div class="small text-black-50" *ngIf="i.typ === 'VV'">{{i.text}}</div>
          </section>
      </mat-expansion-panel>


      <mat-expansion-panel *ngIf="isStatnicovyPredmet" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title><span class="fw-bold" i18n>Obsahová náplň štátnicového predmetu</span></mat-panel-title>
        </mat-expansion-panel-header>
        <hr/>
        <section *ngFor="let i of predmet.popisy">
          <div class="small text-black-50" *ngIf="i.typ === 'ON'">{{i.text}}</div>
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title><span class="fw-bold" i18n>Odporúčaná literatúra</span></mat-panel-title>
        </mat-expansion-panel-header>
        <hr/>
          <section *ngFor="let i of predmet.popisy">
            <div class="small text-black-50" *ngIf="i.typ === 'L'">{{i.text}}</div>
          </section>
      </mat-expansion-panel>

    </mat-accordion>

    <hr/>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
